import React from 'react';
import { ContentGroup } from 'types/generated/graphql';
import Carousels from 'components/Carousels/Carousels';
import { CarouselsSkeleton } from 'components/Carousels/Carousels';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import useQueryMerchZone from 'apollo/merchZone/useQueryMerchZone';

export const _MerchZone = ({
    isLoading,
    contentGroups,
}: {
    isLoading: boolean;
    contentGroups: ContentGroup[];
}) => {
    // Optimistic Skeleton while waiting for the merch zone query to resolve
    // We do not known how many content group we will render, so we skeleton 3
    if (isLoading) {
        return (
            <>
                <CarouselsSkeleton key="carousels-skeleton-one" />
                <CarouselsSkeleton key="carousels-skeleton-two" />
            </>
        );
    }

    return (
        <>
            {contentGroups?.map(({ guid, title, byline }, index) => {
                return (
                    <Carousels
                        key={guid}
                        guid={guid}
                        title={title}
                        byline={byline}
                    />
                );
            })}
        </>
    );
};

const MerchZone = ({ slug }: { slug: string }) => {
    const { isAuthenticated, isLoading: isAuthenticationLoading } =
        useAuthentication();
    const { isLoading, contentGroups } = useQueryMerchZone({
        slug,
        isAuthenticated,
        isAuthenticationLoading,
    });

    return (
        <_MerchZone
            data-component="MerchZone"
            isLoading={isLoading}
            contentGroups={contentGroups}
        />
    );
};

export default MerchZone;
